import { ObjectResizeControls } from './ObjectResizeControls';

export class WallResizeControls extends ObjectResizeControls {
  constructor() {
    super();
    this.children[1].visible = false;
    this.name = 'wallResizeControls';
  }

  update(wall) {
    const sprites = this.children;
    const config = wall.userData.config;
    const { width, height } = config.firstPoint;
    wall.getWorldPosition(this.position);
    wall.getWorldQuaternion(this.quaternion);
    sprites[0].position.y = height / 2;
    sprites[2].position.x = -width / 2;
    sprites[3].position.x = width / 2;
  }
}



// WEBPACK FOOTER //
// ./src/app/custom/Controls/WallResizeControls.ts